import { DepositAddressMissingComponent } from '../../deposit-address-missing/deposit-address-missing.component';
import { Component, computed, effect, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from "@angular/material/dialog";
import { DecimalPipe, NgOptimizedImage } from "@angular/common";
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from "@ngx-translate/core";
import { environment } from '../../../../../../../environments/environment';
import { CopyButtonComponent } from '../../copy-button/copy-button.component';
import QRCode from "qrcode";
import { AuthService } from '../../../services/auth.service';
import { ProjectSettingsService } from '../../../services/project-settings.service';
import { BalanceIncreaseListenerService } from '../../../services/balance-increase-listener.service';
import { Subject, takeUntil } from 'rxjs';
@Component({
    selector: 'app-dialog-balance',
    imports: [
        MatDialogClose,
        MatIconModule,
        TranslateModule,
        CopyButtonComponent,
        DecimalPipe,
        DepositAddressMissingComponent
    ],
    templateUrl: './dialog-balance.component.html',
    styleUrl: './dialog-balance.component.scss'
})
export class DialogBalanceComponent implements OnInit {
  public readonly linkWebVersion: WritableSignal<string> = signal(environment.linkWebVersion);
  public balance: WritableSignal<number> = signal(0);
  public readonly qrCodeUrl: WritableSignal<string | undefined> = signal(undefined);
  public readonly depositAddress: WritableSignal<string | undefined> = signal(undefined);
  public readonly authService: AuthService = inject(AuthService);
  public readonly projectSettingsService: ProjectSettingsService = inject(ProjectSettingsService);
  private readonly _balanceIncreaseListenerService: BalanceIncreaseListenerService = inject(BalanceIncreaseListenerService);

  minBalance = computed(() => this.projectSettingsService.settings()?.minBalance ?? 0);

  paymentStep = signal<'intro' | 'details' | 'success'>('intro');

  heldBalance = computed(() => {
    const user = this.authService.accountDto();
    return user?.heldBalance ?? 0;
  });

  leftNeedDepositBalance = computed(() => {
    const leftDeposit = this.minBalance() - this.heldBalance();
    if (leftDeposit > 0) {
      return leftDeposit;
    }
    return 0;
  });

  percentHoldedBalance = computed(() => {
    return this.heldBalance() / this.minBalance() * 100;
  });
  isGenerating = signal(false);
  showPaymentDetails = signal(false);
  private readonly _destroy$ = new Subject<void>();

  constructor() {

    effect(() => {
      const user = this.authService.accountDto();
      if (user && user.heldBalance > 0) {
        this.showPaymentDetails.set(true);
      }
    });

    effect(async () => {
      const user = this.authService.accountDto();

      if (!user) return;
      this.balance.set(user.balance);

      const { depositAddress } = user;
      this.depositAddress.set(depositAddress);
      this.isGenerating.set(true);
      try {
        this.qrCodeUrl.set(await QRCode.toDataURL(depositAddress, { errorCorrectionLevel: 'high', margin: 0 }));
        this.isGenerating.set(false);
      } catch (err) {
        console.error(err);
          this.isGenerating.set(false);
      }
    }, { allowSignalWrites: true });
  }
  
  ngOnInit(): void {
    this._balanceIncreaseListenerService.balanceIncreased$.pipe(takeUntil(this._destroy$)).subscribe({
      next: () => {
        if (this.paymentStep() === 'details') {
          this.paymentStep.set('success');
        }
      }
    });
  }
}
